import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { isEmpty, forEach } from 'lodash';
import { shareReplay } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from '@helix/platform/shared/api';
import { DataPage } from '@helix/platform/shared/api';

class RxEventDefinitionService {
    constructor(httpClient, rxCommandFactoryService) {
        this.httpClient = httpClient;
        this.rxCommandFactoryService = rxCommandFactoryService;
        this.revertCustomizationCommand = this.rxCommandFactoryService.forResourceType('com.bmc.arsys.rx.application.event.command.RevertEventDefinitionCommand');
    }
    get(eventDefinitionName, options) {
        return this.httpClient.get(this.getUrl(eventDefinitionName), options);
    }
    revertCustomization(eventDefinitionName) {
        return this.revertCustomizationCommand.execute({ eventDefinitionName });
    }
    getUrl(eventDefinitionName) {
        return eventDefinitionName
            ? `/api/rx/application/event/eventdefinition/${encodeURIComponent(eventDefinitionName)}`
            : '/api/rx/application/event/eventdefinition/$NEW$';
    }
    update(eventDefinitionName, eventDefinition) {
        return this.httpClient.put(`/api/rx/application/event/eventdefinition/${encodeURIComponent(eventDefinitionName)}`, eventDefinition);
    }
    create(eventDefinition) {
        return this.httpClient.post(`/api/rx/application/event/eventdefinition`, eventDefinition);
    }
}
RxEventDefinitionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventDefinitionService, deps: [{ token: i1.HttpClient }, { token: i2.RxCommandFactoryService }], target: i0.ɵɵFactoryTarget.Injectable });
RxEventDefinitionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventDefinitionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventDefinitionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.RxCommandFactoryService }]; } });

class RxEventDefinitionCacheService {
    constructor(rxEventDefinitionService) {
        this.rxEventDefinitionService = rxEventDefinitionService;
        this.consumers = new Set();
        this.eventDefinitionCache = new Map();
    }
    getEventDefinition(eventDefinitionName) {
        if (!this.eventDefinitionCache.has(eventDefinitionName)) {
            const eventDefinition$ = this.rxEventDefinitionService.get(eventDefinitionName).pipe(shareReplay(1));
            this.eventDefinitionCache.set(eventDefinitionName, eventDefinition$);
        }
        return this.eventDefinitionCache.get(eventDefinitionName);
    }
    registerConsumer(consumerDestroy$) {
        this.consumers.add(consumerDestroy$);
        consumerDestroy$.subscribe(() => {
            this.consumers.delete(consumerDestroy$);
            if (isEmpty(this.consumers)) {
                this.clearCache();
            }
        });
    }
    clearCache(eventDefinitionNames) {
        if (eventDefinitionNames) {
            forEach(eventDefinitionNames, (eventDefinitionName) => {
                this.eventDefinitionCache.delete(eventDefinitionName);
            });
        }
        else {
            this.eventDefinitionCache.clear();
        }
    }
}
RxEventDefinitionCacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventDefinitionCacheService, deps: [{ token: RxEventDefinitionService }], target: i0.ɵɵFactoryTarget.Injectable });
RxEventDefinitionCacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventDefinitionCacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventDefinitionCacheService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: RxEventDefinitionService }]; } });

const eventDefinitionDataPageQuery = 'com.bmc.arsys.rx.application.event.datapage.EventDefinitionDataPageQuery';
class RxEventDefinitionDataPageService extends DataPage {
    constructor(injector) {
        super(injector, eventDefinitionDataPageQuery);
        this.injector = injector;
    }
}
RxEventDefinitionDataPageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventDefinitionDataPageService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
RxEventDefinitionDataPageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventDefinitionDataPageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventDefinitionDataPageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { RxEventDefinitionCacheService, RxEventDefinitionDataPageService, RxEventDefinitionService };
